import { render, staticRenderFns } from "./Report-group.vue?vue&type=template&id=2765c5f7"
import script from "./Report-group.vue?vue&type=script&lang=js"
export * from "./Report-group.vue?vue&type=script&lang=js"
import style0 from "./Report-group.vue?vue&type=style&index=0&id=2765c5f7&prod&lang=scss"
import style1 from "./Report-group.vue?vue&type=style&index=1&id=2765c5f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports